<ng-container *ngIf="permConfig.isAddAllowed">
    <div class="container-fluid">
        <app-page-title title="Add Vendor AWB"></app-page-title>
          <div class="row">
              <div class="card">
                  <div class="card-body">
                    <form [formGroup]="vendorAWBForm">
                      <div class="row">
                          <div class="col-md-2">
                              <div class="mb-2">
                                  <label for="vendor" class="form-label">Vendor<span class="mandatory">*</span></label>
                                  <input type="text" class="form-control form-control-sm" id="vendor"
                                      placeholder="Search or Enter Name" [resultTemplate]="rt" [inputFormatter]="formatter"
                                      formControlName="txtVendor" [ngbTypeahead]="search" 
                                      [ngClass]="{'is-invalid': (isFormSubmitted || vendorAWBForm.get('txtVendor').touched) && vendorAWBForm.get('txtVendor').errors}" />
                                  <div *ngIf="(isFormSubmitted || vendorAWBForm.get('txtVendor').touched) && vendorAWBForm.get('txtVendor').errors"
                                      class="invalid-feedback">
                                      <span *ngIf="vendorAWBForm.get('txtVendor').errors.required">Name is Required</span>
                                  </div>
                                  <div *ngIf="(isFormSubmitted || vendorAWBForm.get('txtVendor').touched) && vendorAWBForm.get('txtVendor').errors"
                                      class="invalid-feedback">
                                      <span *ngIf="vendorAWBForm.get('txtVendor').errors.maxlength">Name max length is 50 characters</span>
                                  </div>
                                  <ng-template #rt let-r="result" let-t="term">
                                      <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                                      <span> | {{ r['code'] }}</span>
                                  </ng-template>
                              </div>
                          </div>
                          <div class="col-md-3 mt-3">
                              <div class="input-group mt-1">
                                  <input id="importperforma" formControlName="txtFile" type="file"
                                      class="form-control form-control-sm" accept=".xlsx"
                                      (change)="onChangeFileSelect($event)" />
                                  <button type="button" class="btn btn-primary btn-sm d-flex" (click)="uploadFile()">
                                      <i class="bx bx-upload font-size-15 me-1"></i>
                                      Upload
                                  </button>
                              </div>
                              <ng-container *ngIf="showProgressBar">
                                  <div class="progress mt-2">
                                      <div class="progress-bar progress-bar-striped" role="progressbar"
                                          [style.width.%]="progress" [attr.aria-valuenow]="progress" aria-valuemin=" 0"
                                          aria-valuemax="100">
                                          {{progress}}%
                                      </div>
                                  </div>
                              </ng-container>
                          </div>
                      </div>
                    </form>
                  </div>
              </div>
          </div>
          <div class="card">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <div class="d-flex">
                    <span class="mx-2 text-primary">Total: <strong>{{recordStatusObj.totalRecord}}</strong></span>
                    <span class="mx-2 text-success">Mapped: <strong>{{recordStatusObj.mappedRecord}}</strong></span>
                    <span class="mx-2 text-danger">Un-mapped: <strong>{{recordStatusObj.unMappedRecord}}</strong></span>
                  </div>
                </div>
                <div class="table-responsive" style="max-height: 600px; overflow-y: auto;">
                  <table class="table table-bordered table-sm m-0">
                      <thead class="table-light">
                        <tr>
                          <th>Sr.no.</th>
                          <th>Display Name</th>
                          <th>Column Name</th>
                        </tr>
                      </thead>
                      <tbody *ngIf="rowData && rowData.length > 0; else noRecords">
                        <tr *ngFor="let item of rowData; let i = index">
                          <td>{{ i }}</td>
                          <td>
                            <span class="customspan">{{ item.displayname }}</span>
                          </td>
                          <td>
                            <select class="form-select form-select-sm" (change)="updateMapping($event.target.value, item.displayname)">
                              <option value="" selected class="text-muted">Select Column Name</option>
                              <option *ngFor="let column of columnNameList" [value]="column.fieldname">
                                {{ column.name }}
                              </option>
                            </select>
                          </td>
                        </tr>
                      </tbody>
                      <ng-template #noRecords>
                        <tbody>
                          <tr>
                            <td colspan="3" class="text-center">
                              <p class="text-muted mt-3">No records available.</p>
                            </td>
                          </tr>
                        </tbody>
                      </ng-template>
                    </table>
                </div>
                <div class="row mt-3">
                  <div class="col-12">
                    <div class="button-items">
                      <button type="button" class="btn btn-primary w-md"
                        (click)="save()" (keydown.enter)="useEnterKey ? $event.preventDefault() : save()"
                        >Save</button>
                      <a routerLink="/config/vendorawb"><button type="button"
                        class="btn btn-secondary w-md">Cancel</button></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
    </div>
</ng-container>
<ng-container *ngIf="!permConfig.isAddAllowed">
    <app-forbidden></app-forbidden>
</ng-container>